import { Model, Trophy, Parser, Lapse } from '@datamodel';
import { objectMap, mapObjectValues, simpleHash, mod } from '@utils/helpers';

export class User extends Model {
    static CACHE = 1000 * 60 * 5;

    static get uuid() { return 'userId' };
    static get model() {
        return ({
            email: null,
            name: '',
            pic: null,
            // username: '',
            lastUpdated: new Date(Date.now() - 2 * User.CACHE)
        })
    }

    static get keymap() {
        return {
            uuid: User.uuid,
            id: User.uuid,
            profile_photo_url: 'pic',
        }
    }

    static get parseMap() {
        return {
            lastUpdated: (val) => Parser.date(val),
        }
    }

    static get addedDeltas() {
        return ['pic'];
    }

    static calculatePhotoHash(user) {
        if (user.userId) {
            const hash = simpleHash(user.userId, { numeric: true });
            return mod(hash, 8);
        } else {
            return Math.floor(Math.random() * 8);
        }
    }

    static calculateDefaultPhoto(user) {
        const base = 'https://static.festea.party/core/profile-photos/';
        return base + `${this.calculatePhotoHash(user)}.jpg`;
    }

    static get parseCallback() {
        return (parsed) => {
            const user = { ...parsed };
            if (!user.pic) {
                const base = 'https://static.festea.party/core/profile-photos/';
                user.pic = base + `${this.calculatePhotoHash(user)}.jpg`;
            }
            return user;
        }
    }

    constructor(args) {
        super(args);
        Object.assign(this, User.unserialize({ ...User.model, ...args }, { toClass: true }))
    }

}